import { render, staticRenderFns } from "./MapScatter.vue?vue&type=template&id=524c4916&scoped=true&"
import script from "./MapScatter.vue?vue&type=script&lang=js&"
export * from "./MapScatter.vue?vue&type=script&lang=js&"
import style0 from "./MapScatter.vue?vue&type=style&index=0&id=524c4916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c4916",
  null
  
)

component.options.__file = "MapScatter.vue"
export default component.exports